import DownloadButton from './KpiButtons/DownloadSingleKpiButton';
import InfoButton from './KpiButtons/InfoButton';
import DownloadAllKpisButton from './SectionButtons/DownloadAllKpisButton';
import SectionInfoButton from './SectionButtons/SectionInfoButton';
import { ConfigButton } from './KpiButtons/ConfigButton';

// eslint-disable-next-line import/no-unused-modules
export const SECTION_BUTTONS = [SectionInfoButton, DownloadAllKpisButton];
export const KPI_BUTTONS = [ConfigButton, InfoButton, DownloadButton];
export const MAX_SELECTED_KPIS = 6;

// CautionBadge constants
export const ADVISORY_LEVEL_CAUTION = 'caution';
export const CAUTION_BADGE_CLASS_CAUTION = 'caution-badge caution-badge--caution';
export const CAUTION_BADGE_CLASS_INFO = 'caution-badge caution-badge--info';
export const INFO_BADGE_LABEL_DEFAULT = 'Info';
export const CAUTION_LABEL_DEFAULT = 'Caution';

// CautionModal constants
export const ADVISORY_ICON_INFO_COLOR = '#222';
export const ADVISORY_LANGUAGE_CANDIDATE_KEYS = ['en-us', 'en', 'default'];

// Advisory value localization constants
export const ADVISORY_VALUE_TYPE_STRING = 'string';
export const ADVISORY_VALUE_TYPE_OBJECT = 'object';
export const ADVISORY_ARRAY_ITEMS_SEPARATOR = '\n';
export const ADVISORY_LANGUAGE_CODE_SEPARATOR = '-';
export const ADVISORY_PROPERTY_DISPLAY_NAME_TEXT_KEY = 'displayNameTextKey';
export const ADVISORY_PROPERTY_DISPLAY_NAME = 'displayName';
export const ADVISORY_PROPERTY_VALUE = 'value';
export const ADVISORY_PROPERTY_TEXT = 'text';
export const ADVISORY_PROPERTY_LABEL = 'label';
